import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input } from '@angular/core';
import { ElementErrorComponent } from '@components/element-widgets/element-error/element-error.component';
import {
  BlueprintComponentComponent,
} from '@components/fondsportrait/blueprint-component/blueprint-component.component';
import { DokaComponent } from '@components/fondsportrait/doka/doka.component';
import { RouteSelectedFund } from '@components/fondsportrait/selected-fund';
import { TranslocoModule } from '@ngneat/transloco';
import { ApiErrorPipe } from 'src/app/common/pipes/api-error.pipe';
import { ApiSignal, toApiSignal } from 'src/app/common/util/api-signal';
import { BusinessObjectsElementService, FondsportraitBlueprintResponse } from 'src/openapi-client';
import { NgClass } from '@angular/common';

@Component({
  selector: 'wct-fondsportrait',
  standalone: true,
  imports: [TranslocoModule, BlueprintComponentComponent, DokaComponent, ElementErrorComponent, ApiErrorPipe, NgClass],
  templateUrl: './fondsportrait.component.html',
  styleUrl: './fondsportrait.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FondsportraitComponent {
  @Input({ required: false }) public userFundsSelectionVisible: boolean = true; // currently used to identify if we are in user or prelogin context

  protected readonly tabSustainability = 'sustainability';
  protected readonly tabDoka: string = 'doka';
 
  protected readonly dokaOptions: Record<string, string> = {
    'hide-source-column': 'true'
  };

  protected readonly dokaOptionsPrelogon: Record<string, string> = {
    'hide-source-column': 'true',
    'hide-user-public-filter': 'true',
    'show-only-public-documents': 'true'
  };

  protected readonly sustainabilityOptions: Record<string, string> = {
    'document-type': 'Nachhaltigkeitsbezogene Offenlegung',
    'hide-search': 'true',
    'hide-filters': 'true',
    'hide-funds-filter': 'true',
    'hide-document-type-filter': 'true',
    'hide-format-filter': 'true',
    'hide-effective-date-filter': 'true',
    'hide-received-date-filter': 'true',
    'hide-user-public-filter': 'true',
    'show-only-public-documents': 'true',
    'hide-source-column': 'true'
  };
  protected readonly blueprint: ApiSignal<FondsportraitBlueprintResponse> = toApiSignal(
    inject(BusinessObjectsElementService).getFondsportrait(inject(RouteSelectedFund).refresh().get())
  );
}
